<template>

  <div class="border border-gray-200 flex flex-col lg:flex-row">
    <div class="p-8 bg-white flex flex-row space-x-5 w-full lg:w-9/12 items-center lg:border-r border-gray-200">
      <div class="hidden lg:block">
        <img class="w-20" :src="this.campaign.defaultLogo" alt="">
      </div>
      <div class="flex-grow-1 w-full">
        <h2 class="text-gray-700 font-bold text-lg hover:text-pink-500">
          <a target="_blank" :href="`/campaigns/`+this.campaign.id">
            {{ this.campaign.name }}
          </a>
          <span class="bg-blue text-white text-xs py-1 px-3 rounded-full ml-2" v-show="this.campaign.isPledgeDrive">Pledge Drive</span>
        </h2>


        <div v-if="!this.campaign.isPledgeDrive" class="h-5 relative overflow-hidden mb-3 mt-2 progress" >
          <div class="w-full h-full bg-gray-200 absolute"></div>
          <div class="h-full bg-green-500 absolute progress-bar"  role="progressbar"  aria-valuenow="{{ this.campaign.funded }}" aria-valuemin="0" aria-valuemax="100"></div>
          <span class="sr-only">{{ this.campaign.funded }}% Complete</span>
        </div>

        <div v-else class="h-5 relative overflow-hidden mb-3 mt-2 progress">
          <div class="w-full h-full bg-gray-200 absolute"></div>
          <div class="h-full bg-green-500 absolute progress-bar"  role="progressbar"  aria-valuenow="{{ this.campaign?.pledge_drive?.achieved }}" aria-valuemin="0" aria-valuemax="100"></div>
          <span class="sr-only">{{ this.campaign?.pledge_drive?.goal}}% Complete</span>
        </div>



        <div class="flex flex-row justify-between mb-2">

          <div v-if="!this.campaign.isPledgeDrive"  class="text-sm text-gray-700 font-bold">${{this.campaign.total_raised_with_children_campaigns}} Raised ({{this.campaign.funded }}%)</div>
          <div v-if="!this.campaign.isPledgeDrive" class="text-sm text-gray-700 font-bold">${{ this.campaign.goal }} Goal</div>

          <div v-if="this.campaign.isPledgeDrive" class="text-sm text-gray-700 font-bold">Achieved ({{this.campaign?.pledge_drive?.achieved  }}%)</div>
          <div v-if="this.campaign.isPledgeDrive" class="text-sm text-gray-700 font-bold">Goal: {{ this.campaign?.pledge_drive?.goal }} {{ this.campaign?.pledge_drive?.activity_type }}</div>
        </div>


        <div v-if="this.campaign.isPledgeDrive" class="flex flex-row justify-between mb-2">
          <div class="text-xs text-gray-700 font-bold">${{this.campaign?.pledge_drive?.pledge_total_donation_amount }}  Raised</div>
          <div class="text-xs text-gray-700 font-bold">Est. Raised ${{this.campaign?.pledge_drive?.formattedTotalAmountDue }} </div>
        </div>



        <div class="flex flex-row justify-between">
          <div class="text-xs font-bold">
            <a  v-if="this.campaign.children_node_count > 0" class="text-pink hover:text-gray-700" :href="`/sub-campaigns/`+this.campaign.id">Supporters: {{this.campaign.children_node_count}}</a>
            <span v-else> Supporters: {{ this.campaign.children_node_count }}</span>
          </div>
          <div class="text-xs text-gray-700 font-bold">  {{ this.campaign.donation_count_directly_including_children }}  Donors
           <a v-if="this.campaign.campaign_type_id == 2"
              class="text-pink hover:text-gray-700" target="_blank" :href="`/campaign/`+this.campaign.id+`/pledge-drives/`+this.campaign?.pledge_drive?.id+`/pledges`">| {{this.campaign?.pledge_drive?.pledge_count}} Pledges</a>
          </div>
        </div>

      </div>
    </div>

    <div class="p-4 bg-gray-100 flex flex-col w-full lg:w-3/12 items-center justify-center">



      <ul v-if="!this.campaign.isPledgeDrive" >
        <li><a class="text-blue hover:text-blue-600" :href="`/edit-campaign/`+this.campaign.id" >Edit Page</a></li>
        <li><a class="text-blue hover:text-blue-600"  :href="`/campaigns/`+this.campaign.id" >View Page</a></li>

        <li v-if="this.admin"><a class="text-blue hover:text-blue-600" :href="this.archiveLink()">{{this.campaign.is_active ? 'Archive' : 'Un-Archive'}}</a></li>
      </ul>

      <ul v-else>
        <li><a class="text-blue hover:text-blue-600" :href="`/edit-campaign/`+this.campaign.id" >Edit Page</a></li>

        <li><a class="text-blue hover:text-blue-600"  :href="`/campaigns/`+this.campaign.id" >View Page</a></li>


        <li v-if="this.admin"><a class="text-blue hover:text-blue-600" :href="this.archiveLink()">{{this.campaign.is_active ? 'Archive' : 'Un-Archive'}}</a></li>

      </ul>

      <a v-if="this.campaign.isPledgeDrive"  :href="`/campaign/`+this.campaign.id+`/pledge-drives/`+this.campaign?.pledge_drive?.id+`/pledges`" class="bg-pink hover:bg-pink-700 text-white w-full d-block uppercase text-center font-bold py-3 block text-sm my-5 mx-0 focus:outline-none  focus:ring-pink-200">Pledge Drive Manager</a>

    </div>
  </div>


</template>

<script>

export default {
  props: {
    admin: false,
    campaign: {},
  },
  methods: {
    archiveLink() {
      if (this.campaign.is_active) {
        return '/admin/campaign/archive-campaign/'+this.campaign.id
      }
      return '/admin/campaign/archive-campaign/'+this.campaign.id+'/1' //un-archive
    }
  }
}
</script>
